import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "../context/SessionContext";

/**
 * Which base paths each role may access.
 * SUPER_ADMIN is omitted — has unrestricted access.
 */
const ROLE_ALLOWED_PATHS: Record<string, string[]> = {
  ADMIN: [
    "/dashboard", "/home", "/offers", "/instructors", "/classes",
    "/calendar", "/students", "/passes", "/events", "/notifications", "/settings",
  ],
  INSTRUCTOR: [
    "/dashboard", "/home", "/classes", "/calendar", "/notifications", "/settings",
  ],
  USER: [
    "/dashboard", "/home", "/classes", "/passes", "/calendar", "/events", "/notifications", "/settings",
  ],
};

function getUserRole(): string {
  try {
    const raw = localStorage.getItem("user") || sessionStorage.getItem("user");
    const user = raw ? JSON.parse(raw) : null;
    return (user?.role || "").toUpperCase();
  } catch {
    return "";
  }
}

const ProtectedRoute: React.FC = () => {
  const { isLoggedIn } = useSession();
  const location = useLocation();

  if (!isLoggedIn) return <Navigate to="/" replace />;

  const role = getUserRole();

  // SUPER_ADMIN can access everything
  if (role === "SUPER_ADMIN") return <Outlet />;

  // Extract base path: "/instructors/report/123" → "/instructors"
  const basePath = "/" + (location.pathname.split("/")[1] || "");

  const allowed = ROLE_ALLOWED_PATHS[role];
  if (allowed && !allowed.includes(basePath)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
